<template>
  <div class="stepper__container">
    <ul class="stepper stepper__header">
      <li v-for="(header, index) in headers" :key="header">
        <h1
          :class="[
            'stepper__title',
              shouldApplyTitleClass(index)
              ? 'stepper__title--active'
              : 'stepper__title--disabled'
          ]"
        >
          {{ header }}
        </h1>
      </li>
    </ul>

    <ul class="stepper stepper__lines">
      <li v-for="step in numberOfSteps" :key="step">
        <div
          :class="[
            'stepper__line',
            currentStep >= step
              ? 'stepper__line--active'
              : 'stepper__line--disabled'
          ]"
        ></div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    currentStep: {
      type: Number,
      default: 1,
      required: true
    }
  },
  data() {
    return {
      numberOfSteps: 3,
      headers: ["Dados de Cadastro", "Informações do seu negócio"]
    };
  },
  methods:{
    shouldApplyTitleClass(index) {
      return index === 0 || this.currentStep === 3;
    }
  }
};
</script>

<style lang="stylus" scoped>
$active-color = #F3B331
$disabled-color = #C8CDDA

.stepper
  font-family 'Lato', sans-serif !important
  display flex
  flex-flow row nowrap
  justify-content flex-start
  align-items center

  li
    list-style-type none

  &__container
    width 96%
    margin 24px auto 32px auto

    @media screen and (min-width 500px)
      width 80%
      margin 60px auto

  &__header
    li
      text-align center

      &:first-child
        width 66.66%

      &:last-child
        width 33.33%

  &__title
    font-size 10px
    line-height 24px
    font-weight bold
    text-transform uppercase

    @media screen and (max-width 320px)
      font-size 8px

    @media screen and (min-width 500px)
      font-size 14px

    &--disabled
      color $disabled-color

    &--active
      color $active-color

  &__line
    width 100%
    height 8px

    &--disabled
      background-color $disabled-color

    &--active
      background-color $active-color

  &__lines
    li
      width 33.33%

      &:first-child
        .stepper__line
          border-radius 4px 0 0 4px

      &:last-child
        .stepper__line
          border-radius 0 4px 4px 0
</style>
